import { render, staticRenderFns } from "./tableNoComparison.vue?vue&type=template&id=23ffaf0b"
import script from "./tableNoComparison.vue?vue&type=script&lang=js"
export * from "./tableNoComparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports